import { createEffect } from 'effector'

import { trackEvent } from 'helpers/analytics'
import { urlTo, goTo } from 'helpers/router'

import { type IsaTransferRequestDTO, submitIsaTransferRequest } from 'app/effector/isa-transfer/api'
import { type IsaProvider } from 'app/effector/isa-transfer/models'

import { fetchClient } from 'app/redux/actions/client'
import { closeIsaPanel, fetchPortfolios } from 'app/redux/actions/portfolios'
import { showFailToast } from 'app/redux/actions/ui'
import store from 'app/redux/store/store.js'

import { type IsaTransferFormData } from './IsaTransferFormData'
import { scrollToError } from './utils'

import { regulatoryTypes } from 'constants/portfolio'

export const scrollToErrorFx = createEffect(() => {
  setTimeout(scrollToError, 1)
})

export const submitTransferIsaRequestFx = createEffect(
  async (request: IsaTransferRequestDTO) => await submitIsaTransferRequest(request),
)

export const sendSubmitEventFx = createEffect(
  ({ form, selectedProvider }: { form: IsaTransferFormData; selectedProvider: IsaProvider }) => {
    trackEvent({
      action: 'transfer_submit',
      transfer_type: regulatoryTypes.ISA,
      reference_number: `${form.isa_account}`,
      provider: `${selectedProvider.name}`,
      transfer_size: `${form.transfer_type}`,
      transfer_current_year: `${form.transfer_current_year}`,
      transfer_previous_years: `${form.transfer_previous_years}`,
      previous_years_amount: `${form.previous_years_amount}`,
    })
  },
)

export const navigateToSuccessFx = createEffect(() => {
  goTo(urlTo('dashboard.transfer-isa-altus.success'))
})

export const navigateToSignatureStepFx = createEffect(() => {
  goTo(urlTo('dashboard.transfer-isa-altus.signature'))
})

export const navigateToPortfolioByIdFx = createEffect((portfolioId: number) => {
  goTo(urlTo('dashboard.portfolio', { id: portfolioId }))
})

export const openJotFormLinkFx = createEffect((jotformLink: string) => {
  window.open(jotformLink, '_blank')
})

export const fetchPortfoliosFx = createEffect(async () => {
  await store.dispatch(fetchPortfolios())
})

export const fetchClientFx = createEffect(() => {
  store.dispatch(fetchClient())
})

export const closeIsaPanelFx = createEffect((portfolioId: number) => {
  store.dispatch(closeIsaPanel(portfolioId))
})

export const showFailToastFx = createEffect(() => {
  showFailToast()
})
